export default [
  {
    title: 'Home',
    icon: 'mdi-home',
    to: 'Home',
    keywords: ['หน้าแรก', 'home']
  },
  {
    title: 'Dashboard',
    icon: 'mdi-chart-line',
    subMenus: [
      {
        title: 'Sales Dashboard',
        icon: 'mdi-monitor-dashboard',
        to: 'NewDashboard',
        keywords: ['ยอดขาย', 'แดชบอร์ด', 'sales', 'dashboard']
      }
      // {
      //   title: 'Visitors Dashboard',
      //   icon: 'mdi-file-chart-outline',
      //   to: 'VisitorsDashboard'
      // }
    ]
  },
  {
    title: 'Products',
    icon: 'mdi-tshirt-crew',
    subMenus: [
      {
        title: 'Product list',
        icon: 'mdi-format-list-bulleted',
        to: 'Products',
        keywords: ['สินค้า', 'รายการสินค้า', 'product', 'item']
      },
      {
        title: 'Product Attributes',
        icon: 'mdi-format-list-bulleted',
        to: 'ProductAttributes',
        keywords: ['คุณสมบัติสินค้า', 'แอตทริบิวต์', 'product', 'attribute']
      },
      {
        title: 'Sorting Product',
        icon: 'mdi-order-numeric-ascending',
        to: 'SortingProduct',
        keywords: ['จัดเรียงสินค้า', 'เรียงลำดับ', 'sort', 'product']
      },
      {
        title: 'Attributes Assigner',
        icon: 'mdi-order-bool-ascending-variant',
        to: 'AttributesAssigner',
        keywords: ['กำหนดแอตทริบิวต์', 'assign', 'attribute']
      },
      {
        title: 'Product Notified',
        icon: 'mdi-order-bool-ascending-variant',
        to: 'ProductNotified',
        keywords: ['แจ้งเตือนสินค้า', 'สินค้ามาแล้ว', 'product', 'notify']
      },
      {
        title: 'Weight and Dimension',
        icon: 'mdi-scale',
        to: 'ProductWeightAndDimension',
        keywords: ['น้ำหนัก', 'ขนาด', 'weight', 'dimension']
      }
      // {
      //   title: 'Sorting Product (Kids)',
      //   icon: 'mdi-order-numeric-ascending',
      //   to: 'SortingProductKids'
      // }
    ]
  },
  {
    title: 'Inventory',
    icon: 'mdi-warehouse',
    subMenus: [
      {
        title: 'Product Inventory',
        icon: 'mdi-format-list-bulleted',
        to: 'ProductInventory',
        keywords: ['สต็อก', 'สต๊อก', 'คลังสินค้า', 'stock', 'inventory']
      },
      {
        title: 'PO Overview',
        icon: 'mdi-format-list-bulleted',
        to: 'PurchasesOrderOverview',
        keywords: ['ภาพรวมใบสั่งซื้อ', 'po', 'purchase', 'order', 'overview']
      },
      {
        title: 'In Transit Report',
        icon: 'mdi-clipboard-list-outline',
        to: 'InTransitReport',
        keywords: ['สินค้าระหว่างทาง', 'รายงานขนส่ง', 'in transit', 'report']
      },
      {
        title: 'Delivery Notes',
        icon: 'mdi-format-list-bulleted',
        to: 'DeliveryNoteNew',
        keywords: ['ใบส่งของ', 'delivery', 'note']
      },
      {
        title: 'Withdraw Notes',
        icon: 'mdi-format-list-bulleted',
        to: 'WithdrawNoteNew',
        keywords: ['ใบเบิกของ', 'เบิกสินค้า', 'withdraw', 'note']
      },
      {
        title: 'Stock Movement New',
        icon: 'mdi-package-variant',
        to: 'StockMovementNew',
        keywords: ['เคลื่อนไหวสต็อก', 'ความเคลื่อนไหว', 'stock', 'movement']
      },
      {
        title: 'Stock Count',
        icon: 'mdi-format-list-bulleted',
        to: 'StockCountList',
        keywords: ['นับสต็อก', 'เช็คสต็อก', 'ตรวจนับ', 'count', 'stock']
      },
      {
        title: 'QR TO CSV',
        icon: 'mdi-qrcode',
        to: 'QRToCsv',
        keywords: ['คิวอาร์เป็นซีเอสวี', 'qr', 'csv']
      },
      {
        title: 'Packing List',
        icon: 'mdi-tshirt-crew-outline',
        to: 'PackingList',
        keywords: ['รายการแพ็ค', 'แพ็คสินค้า', 'packing', 'list']
      },
      {
        title: 'Packing List New',
        icon: 'mdi-tshirt-crew-outline',
        to: 'PackingListNew',
        keywords: ['รายการแพ็คใหม่', 'แพ็คสินค้า', 'packing', 'list', 'new']
      },
      {
        title: 'None Display Product',
        icon: 'mdi-library-shelves',
        to: 'noneDisplayProductList',
        keywords: ['สินค้าไม่แสดง', 'none display', 'product']
      },
      {
        title: 'Move Products Presets',
        icon: 'mdi-cog',
        to: 'MoveProductsPresets',
        keywords: ['พรีเซ็ตย้ายสินค้า', 'move', 'product', 'preset']
      },
      {
        title: 'Inventory Posting',
        icon: 'mdi-post',
        to: 'InventoryPosting',
        keywords: ['โพสต์สต็อก', 'ปรับสต็อก', 'inventory', 'posting']
      },
      {
        title: 'Batch Transfer',
        icon: 'mdi-file-upload-outline',
        to: 'BatchTransfer',
        keywords: ['อัปโหลดไฟล์', 'สร้างใบเบิกสินค้า', 'withdraw note', 'transfer order', 'batch', 'csv', 'upload']
      }
    ]
  },
  // {
  //   title: 'LINE MyShop',
  //   icon: 'mdi-alpha-l-circle',
  //   subMenus: [
  //     {
  //       title: 'Product Mapping',
  //       icon: 'mdi-swap-horizontal',
  //       to: 'LineMyShop'
  //     }
  //   ]
  // },
  {
    title: 'Management',
    icon: 'mdi-chart-line',
    subMenus: [
      {
        title: 'Members',
        icon: 'mdi-account-group',
        to: 'MemberManagement',
        keywords: ['สมาชิก', 'ลูกค้า', 'member', 'customer']
      },
      {
        title: 'Celebs',
        icon: 'mdi-account-star',
        to: 'CelebsManagement',
        keywords: ['เซเลบ', 'ดารา', 'celeb', 'celebrity']
      },
      {
        title: 'Careers',
        icon: 'mdi-account-group-outline',
        to: 'Careers',
        keywords: ['สมัครงาน', 'ตำแหน่งงาน', 'career', 'job']
      },
      {
        title: 'Supplier Apply',
        icon: 'mdi-factory',
        to: 'SupplierApply',
        keywords: ['สมัครซัพพลายเออร์', 'ผู้ผลิต', 'supplier', 'apply']
      },
      {
        title: 'Add Member Spending',
        icon: 'mdi-cash-plus',
        to: 'AddMemberSpending',
        keywords: ['เพิ่มยอดใช้จ่าย', 'ยอดสมาชิก', 'add', 'member', 'spending']
      },
      {
        title: 'Check Member Spending',
        icon: 'mdi-account-cash',
        to: 'CheckMemberSpending',
        keywords: ['ตรวจยอดใช้จ่าย', 'ยอดสมาชิก', 'check', 'member', 'spending']
      },
      {
        title: 'Promotions',
        icon: 'mdi-tag-multiple',
        to: 'PromotionManagement',
        keywords: ['โปรโมชั่น', 'โปรโมชัน', 'ส่วนลด', 'promotion', 'discount']
      },
      {
        title: 'Broadcast',
        icon: 'mdi-bullhorn',
        to: 'Broadcast',
        keywords: ['บรอดแคสต์', 'ส่งข้อความ', 'broadcast']
      },
      // {
      //   title: 'Sms Logs',
      //   icon: 'mdi-message-text',
      //   to: 'SmsLogs'
      // },
      // {
      //   title: 'Line Logs',
      //   icon: 'mdi-math-log',
      //   to: 'LineLogs'
      // },
      // {
      //   title: 'Reprint Receipt',
      //   icon: 'mdi-receipt',
      //   to: 'ReprintReceipt'
      // },
      {
        title: 'Export Product Ads',
        icon: 'mdi-file-export',
        to: 'ExportProductAds',
        keywords: ['ส่งออกโฆษณาสินค้า', 'export', 'product', 'ads']
      },
      // {
      //   title: 'Settings',
      //   icon: 'mdi-cog',
      //   to: 'MemberSettings'
      // }
      {
        title: 'Monthly Report Tag Setting',
        icon: 'mdi-email-newsletter',
        to: 'MonthlyReportTagSetting',
        keywords: ['รายงานประจำเดือน', 'แท็กรายงาน', 'รายงานแท็ก', 'monthly', 'report', 'tag']
      }
    ]
  },
  {
    title: 'Prototype',
    icon: 'mdi-clipboard-check-multiple-outline',
    subMenus: [
      {
        title: 'Materials',
        icon: 'mdi-palette-swatch',
        to: 'MaterialsList',
        keywords: ['วัตถุดิบ', 'วัสดุ', 'material']
      },
      {
        title: 'Care Label',
        icon: 'mdi-washing-machine',
        to: 'CareLabelList',
        keywords: ['ป้ายดูแลผ้า', 'แคร์เลเบล', 'care', 'label']
      },
      {
        title: 'Fabrics',
        icon: 'mdi-tshirt-crew',
        to: 'FabricsList',
        keywords: ['ผ้า', 'เนื้อผ้า', 'fabric']
      },
      {
        title: 'Sketch',
        icon: 'mdi-clipboard-edit-outline',
        to: 'SketchListOld',
        keywords: ['สเก็ตช์', 'แบบร่าง', 'sketch']
      },
      {
        title: 'Order',
        icon: 'mdi-clipboard-list-outline',
        to: 'OrderFormListOld',
        keywords: ['ใบสั่งผลิต', 'order form', 'prototype order']
      },
      {
        title: 'Manufacture',
        icon: 'mdi-calendar-clock-outline',
        to: 'ManufactureListOld',
        keywords: ['ผลิต', 'การผลิต', 'manufacture']
      },
      {
        title: 'Sketch (NEW)',
        icon: 'mdi-clipboard-edit-outline',
        to: 'SketchList',
        keywords: ['สเก็ตช์ใหม่', 'แบบร่าง', 'sketch', 'new']
      },
      {
        title: 'Order (NEW)',
        icon: 'mdi-clipboard-list-outline',
        to: 'OrderFormList',
        keywords: ['ใบสั่งผลิตใหม่', 'order form', 'new']
      },
      {
        title: 'Manufacture (NEW)',
        icon: 'mdi-calendar-clock-outline',
        to: 'ManufactureList',
        keywords: ['ผลิตใหม่', 'การผลิต', 'manufacture', 'new']
      },
      {
        title: 'Tracking',
        icon: 'mdi-truck-check',
        to: 'TrackingList',
        keywords: ['ติดตาม', 'ติดตามการผลิต', 'tracking']
      },
      {
        title: 'Fabric Orders',
        icon: 'mdi-receipt',
        to: 'FabricOrdersList',
        keywords: ['สั่งผ้า', 'ใบสั่งผ้า', 'fabric', 'order']
      },
      {
        title: 'Product Mapping',
        icon: 'mdi-package',
        to: 'ProductMappingListOld',
        keywords: ['แมปสินค้า', 'จับคู่สินค้า', 'product', 'mapping']
      },
      {
        title: 'Product Mapping (NEW)',
        icon: 'mdi-package',
        to: 'ProductMappingList',
        keywords: ['แมปสินค้าใหม่', 'จับคู่สินค้า', 'product', 'mapping', 'new']
      },
      {
        title: 'Attribute Management',
        icon: 'mdi-application-cog',
        to: 'PrototypeAttribute',
        keywords: ['จัดการแอตทริบิวต์', 'attribute', 'management']
      }
    ]
  },
  {
    title: 'Report Hub',
    icon: 'mdi-file-document-multiple-outline',
    to: 'NewReport',
    keywords: ['ศูนย์รายงาน', 'รายงาน', 'report', 'hub']
  },
  // {
  //   title: 'Reports',
  //   icon: 'mdi-clipboard-list-outline',
  //   subMenus: [
  //     {
  //       title: 'ReportColor',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'ReportColors'
  //     },
  //     {
  //       title: 'ReportColorSize',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'ReportColorsWithSizes'
  //     },
  //     {
  //       title: 'Pick Pack Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'PickPackReport'
  //     },
  //     {
  //       title: 'DHL Express Pickup Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'DhlPickupReport'
  //     },
  //     {
  //       title: 'Offline Conversion Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'OfflineConversionReport'
  //     },
  //     {
  //       title: 'LINE Linked Report (Branch)',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'BranchLineLinkedReport'
  //     },
  //     {
  //       title: 'LINE Linked Report (Cashier)',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'CashierLineLinkedReport'
  //     },
  //     {
  //       title: 'Cashiers Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewCashierReport'
  //     },
  //     // {
  //     //   title: 'Admin Sales Report',
  //     //   icon: 'mdi-clipboard-list-outline',
  //     //   to: 'NewAdminReport'
  //     // },
  //     {
  //       title: 'Report Group Categories',
  //       icon: 'mdi-monitor-dashboard',
  //       to: 'NewReportCategories'
  //     },
  //     {
  //       title: 'POS Sales Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewPosReport'
  //     },
  //     {
  //       title: 'POS Payment Summary',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'PosPaymentSummary'
  //     },
  //     {
  //       title: 'Online Sales Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewSaleReport'
  //     },
  //     {
  //       title: 'Online International Sales Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewSaleReportInternational'
  //     },
  //     // {
  //     //   title: 'Online Singapore Sales Report',
  //     //   icon: 'mdi-clipboard-list-outline',
  //     //   to: 'NewSaleReportSingapore'
  //     // },
  //     {
  //       title: 'Fulfillment',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewFulfillmentReport'
  //     },
  //     {
  //       title: 'Fulfillment International',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewFulfillmentReportInternational'
  //     },
  //     {
  //       title: 'Sales Product Report',
  //       icon: 'mdi-tshirt-crew-outline',
  //       to: 'SaleProductReport'
  //     },
  //     {
  //       title: 'POS Sales Product Report',
  //       icon: 'mdi-tshirt-crew-outline',
  //       to: 'PosSaleProductReport'
  //     },
  //     // {
  //     //   title: 'Stock Cost / Value',
  //     //   icon: 'mdi-clipboard-list-outline',
  //     //   to: 'StockCostValue'
  //     // }
  //     // {
  //     //   title: 'Tracking Behavior Report (Overall)',
  //     //   icon: 'mdi-list-status',
  //     //   to: 'TrackingBehaviorOverallReport'
  //     // },
  //     // {
  //     //   title: 'Tracking Behavior Report (Warehouse)',
  //     //   icon: 'mdi-list-status',
  //     //   to: 'TrackingBehaviorWarehouseReport'
  //     // },
  //     {
  //       title: 'Report New Member',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'NewMemberReport'
  //     },
  //     {
  //       title: 'Cofen Chat Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'CofenChatReport'
  //     },
  //     {
  //       title: 'Cofen Feedback Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'CofenFeedbackReport'
  //     },
  //     {
  //       title: 'In Dispute Report',
  //       icon: 'mdi-clipboard-list-outline',
  //       to: 'IdpReport'
  //     }
  //   ]
  // },
  {
    title: 'PMS',
    icon: 'mdi-clipboard-list-outline',
    subMenus: [
      {
        title: 'Score Setup',
        icon: 'mdi-chart-gantt',
        to: 'PerformanceScoreSetup',
        keywords: ['ตั้งค่าคะแนน', 'score', 'setup']
      },
      {
        title: 'Evaluation',
        icon: 'mdi-chart-bar-stacked',
        to: 'PerformanceEvaluation',
        keywords: ['ประเมินผล', 'การประเมิน', 'evaluation']
      },
      {
        title: 'Performance Review',
        icon: 'mdi-clipboard-list-outline',
        to: 'PerformanceReview',
        keywords: ['รีวิวผลงาน', 'ประเมินผลงาน', 'performance', 'review']
      },
      {
        title: 'Performance Report',
        icon: 'mdi-clipboard-list-outline',
        to: 'PerformanceReport',
        keywords: ['รายงานผลงาน', 'performance', 'report']
      },
      {
        title: 'Employees List',
        icon: 'mdi-clipboard-list-outline',
        to: 'EmployeesList',
        keywords: ['รายชื่อพนักงาน', 'พนักงาน', 'employee', 'list']
      },
      {
        title: 'Daily Briefs Broadcast',
        icon: 'mdi-clipboard-list-outline',
        to: 'BroadcastMessage',
        keywords: ['ส่งสรุปประจำวัน', 'บรอดแคสต์', 'daily', 'brief', 'broadcast']
      },
      {
        title: 'Daily Briefs Report',
        icon: 'mdi-clipboard-list-outline',
        to: 'DailyBriefs',
        keywords: ['รายงานสรุปประจำวัน', 'daily', 'brief', 'report']
      },
      {
        title: 'Customer Questionnaires',
        icon: 'mdi-clipboard-list-outline',
        to: 'CustomerQuestionnaires',
        keywords: ['แบบสอบถามลูกค้า', 'customer', 'questionnaire', 'survey']
      },
      {
        title: 'Settings',
        icon: 'mdi-cog',
        to: 'PerformanceReportSettings',
        keywords: ['ตั้งค่า pms', 'setting']
      }
    ]
  },
  {
    title: 'Purchases',
    icon: 'mdi-clipboard-list-outline',
    subMenus: [
      // {
      //   title: 'Raw Material',
      //   icon: 'mdi-box-cutter',
      //   to: 'PurchasesItems',
      //   keywords: ['วัตถุดิบ', 'rm', 'raw', 'material']
      // },
      {
        title: 'Vendors',
        icon: 'mdi-face-agent',
        to: 'PurchasesVendors',
        keywords: ['ผู้ขาย', 'คู่ค้า', 'vendor', 'supplier']
      },
      // {
      //   title: 'RM Orders',
      //   icon: 'mdi-clipboard-list-outline',
      //   to: 'PurchasesOrders',
      //   keywords: ['ใบสั่งซื้อวัตถุดิบ', 'rm', 'order', 'purchase']
      // },
      {
        title: 'FG Orders',
        icon: 'mdi-clipboard-list-outline',
        to: 'PurchasesFinishedGoodsOrders',
        keywords: ['ใบสั่งซื้อสินค้าสำเร็จรูป', 'fg', 'finished goods', 'order']
      },
      // {
      //   title: 'Assembly Orders',
      //   icon: 'mdi-clipboard-list-outline',
      //   to: 'PurchasesAssemblyOrders',
      //   keywords: ['ใบสั่งประกอบ', 'assembly', 'order']
      // },
      // {
      //   title: 'Assembly BOM',
      //   icon: 'mdi-clipboard-list-outline',
      //   to: 'PurchasesAssemblyBOM',
      //   keywords: ['สูตรการประกอบ', 'bom', 'assembly']
      // },
      {
        title: 'Customers',
        icon: 'mdi-face-woman',
        to: 'PurchasesCustomers',
        keywords: ['ลูกค้าจัดซื้อ', 'customer']
      },
      {
        title: 'UOM',
        icon: 'mdi-size-xl',
        to: 'PurchasesUOM',
        keywords: ['หน่วยนับ', 'unit', 'uom']
      }
    ]
  },
  {
    title: 'Exportation',
    icon: 'mdi-truck-cargo-container',
    subMenus: [
      {
        title: 'Countries',
        icon: 'mdi-cash-multiple',
        to: 'ExportCountries',
        keywords: ['ประเทศ', 'export', 'country']
      },
      {
        title: 'Price Conversions',
        icon: 'mdi-currency-usd',
        to: 'ExportPriceConversions',
        keywords: ['แปลงราคา', 'อัตราแปลง', 'price', 'conversion']
      },
      {
        title: 'Distributors',
        icon: 'mdi-account-tie',
        to: 'ExportDistributors',
        keywords: ['ผู้จัดจำหน่าย', 'distributor']
      },
      {
        title: 'Products Display',
        icon: 'mdi-package-variant',
        to: 'ExportProductsDisplay',
        keywords: ['แสดงสินค้าส่งออก', 'product', 'display']
      },
      {
        title: 'Product Groups Display',
        icon: 'mdi-image-multiple',
        to: 'ExportCollectionsDisplay',
        keywords: ['แสดงกลุ่มสินค้า', 'product', 'group', 'collection', 'display']
      },
      {
        title: 'Product Information',
        icon: 'mdi-format-list-bulleted',
        to: 'ProductInformation',
        keywords: ['ข้อมูลสินค้า', 'product', 'information']
      },
      {
        title: 'B2B WMS Status',
        icon: 'mdi-warehouse',
        to: 'ExportB2BWmsStatus',
        keywords: ['เช็คสถานะ wms', 'สถานะ so', 'b2b', 'wms', 'reserved', 'ac2']
      }
    ]
  },
  {
    title: 'Store Reports',
    icon: 'mdi-clipboard-list-outline',
    subMenus: [
      {
        title: 'Stock Aging Report',
        icon: 'mdi-timetable',
        to: 'StockAgingReport',
        keywords: ['รายงานอายุสต็อก', 'stock', 'aging', 'report']
      },
      {
        title: 'Sales Products Report',
        icon: 'mdi-clipboard-list-outline',
        to: 'SalesProductsReport',
        keywords: ['รายงานยอดขายสินค้า', 'sales', 'product', 'report']
      },
      {
        title: 'Best Seller Report',
        icon: 'mdi-thumb-up-outline',
        to: 'BestSellerReport',
        keywords: ['สินค้าขายดี', 'best seller', 'report']
      }
    ]
  },
  {
    title: 'Tiktok',
    icon: 'mdi-tshirt-crew',
    subMenus: [
      {
        title: 'Product list',
        icon: 'mdi-format-list-bulleted',
        to: 'TiktokProductsList',
        keywords: ['สินค้า tiktok', 'ติ๊กต็อก', 'tiktok', 'product']
      },
      {
        title: 'Order',
        icon: 'mdi-clipboard-text-multiple-outline',
        to: 'TiktokOrderList',
        keywords: ['ติ๊กต็อก', 'ออเดอร์ tiktok', 'tiktok order']
      },
      {
        title: 'Return Order',
        icon: 'mdi-keyboard-return',
        to: 'TiktokReturnOrder',
        keywords: ['คืนสินค้า tiktok', 'ติ๊กต็อก', 'tiktok', 'return']
      },
      {
        title: 'Sync Order Error',
        icon: 'mdi-sync-alert',
        to: 'TiktokSyncOrderError',
        keywords: ['ซิงค์ออเดอร์ผิดพลาด', 'tiktok', 'sync', 'error']
      },
      {
        title: 'Request Logs',
        icon: 'mdi-api',
        to: 'TiktokRequestLog',
        keywords: ['บันทึก request', 'tiktok', 'request', 'log']
      },
      {
        title: 'Webhook Logs',
        icon: 'mdi-api',
        to: 'TiktokWebhookLog',
        keywords: ['บันทึก webhook', 'tiktok', 'webhook', 'log']
      },
      {
        title: 'Token Logs',
        icon: 'mdi-key',
        to: 'TiktokTokenLog',
        keywords: ['บันทึก token', 'tiktok', 'token', 'log']
      },
      {
        title: 'Authorized Shop',
        icon: 'mdi-store',
        to: 'TiktokAuthorizedShop',
        keywords: ['ร้านที่เชื่อมต่อ', 'tiktok', 'authorized', 'shop']
      }
    ]
  },
  {
    title: 'Lazada',
    icon: 'mdi-tshirt-crew',
    subMenus: [
      {
        title: 'Product list',
        icon: 'mdi-format-list-bulleted',
        to: 'LazadaProductsList',
        keywords: ['สินค้า lazada', 'ลาซาด้า', 'lazada', 'product']
      },
      {
        title: 'Order',
        icon: 'mdi-clipboard-text-multiple-outline',
        to: 'LazadaOrderList',
        keywords: ['ลาซาด้า', 'ออเดอร์ lazada', 'lazada order']
      },
      {
        title: 'Return Order',
        icon: 'mdi-keyboard-return',
        to: 'LazadaReturnOrder',
        keywords: ['คืนสินค้า lazada', 'ลาซาด้า', 'lazada', 'return']
      },
      {
        title: 'Sync Order Error',
        icon: 'mdi-sync-alert',
        to: 'LazadaSyncOrderError',
        keywords: ['ซิงค์ออเดอร์ผิดพลาด', 'lazada', 'sync', 'error']
      },
      {
        title: 'Request Logs',
        icon: 'mdi-api',
        to: 'LazadaRequestLog',
        keywords: ['บันทึก request', 'lazada', 'request', 'log']
      },
      {
        title: 'Webhook Logs',
        icon: 'mdi-api',
        to: 'LazadaWebhookLog',
        keywords: ['บันทึก webhook', 'lazada', 'webhook', 'log']
      },
      {
        title: 'Token Logs',
        icon: 'mdi-key',
        to: 'LazadaTokenLog',
        keywords: ['บันทึก token', 'lazada', 'token', 'log']
      },
      {
        title: 'Authorized Shop',
        icon: 'mdi-store',
        to: 'LazadaAuthorizedShop',
        keywords: ['ร้านที่เชื่อมต่อ', 'lazada', 'authorized', 'shop']
      }
    ]
  },
  {
    title: 'Flash',
    icon: 'mdi-tshirt-crew',
    subMenus: [
      {
        title: 'Request Logs',
        icon: 'mdi-api',
        to: 'FlashRequestLog',
        keywords: ['บันทึก request', 'flash', 'request', 'log']
      },
      {
        title: 'Webhook Logs',
        icon: 'mdi-api',
        to: 'FlashWebhookLog',
        keywords: ['บันทึก webhook', 'flash', 'webhook', 'log']
      }
    ]
  },
  {
    title: 'AC2',
    icon: 'mdi-warehouse',
    subMenus: [
      {
        title: 'Token',
        icon: 'mdi-key',
        to: 'Ac2TokenLog'
      },
      {
        title: 'Request Logs',
        icon: 'mdi-api',
        to: 'Ac2RequestLog'
      },
      {
        title: 'Webhook Logs',
        icon: 'mdi-webhook',
        to: 'Ac2WebhookLog',
        keywords: ['บันทึก webhook', 'ac2 webhook', 'webhook', 'log', 'inbound']
      },
      {
        title: 'Queues',
        icon: 'mdi-human-queue',
        to: 'Ac2Queues'
      },
      {
        title: 'Warehouse Config',
        icon: 'mdi-warehouse',
        to: 'Ac2WarehouseConfig',
        keywords: ['warehouse mapping', 'ผูก warehouse', 'owner', 'wh_id', 'ac2 warehouse']
      },
      {
        title: 'Document Config',
        icon: 'mdi-file-document-outline',
        to: 'Ac2DocumentConfig',
        keywords: ['document config', 'sla', 'finished within', 'delivery note', 'withdraw note', 'order', 'เอกสาร']
      }
    ]
  },
  {
    title: 'Stock Location',
    icon: 'mdi-map-marker',
    subMenus: [
      {
        title: 'Manage Location',
        icon: 'mdi-cog',
        to: 'ManageStockLocation',
        keywords: ['จัดการตำแหน่ง', 'location', 'manage']
      },
      {
        title: 'Find Product',
        icon: 'mdi-magnify',
        to: 'FindProductLocation',
        keywords: ['หาสินค้า', 'ค้นหาสินค้า', 'ตำแหน่งสินค้า', 'find', 'location']
      },
      {
        title: 'Print Location',
        icon: 'mdi-printer',
        to: 'PrintLocation',
        keywords: ['พิมพ์ตำแหน่ง', 'print', 'location']
      }
    ]
  },
  {
    title: 'WMS Mapping',
    icon: 'mdi-map-marker-multiple',
    subMenus: [
      {
        title: 'Manage Location',
        icon: 'mdi-cog',
        to: 'StockMappingManage',
        keywords: ['จัดการตำแหน่ง', 'location', 'manage', 'mapping']
      },
      {
        title: 'Find Product',
        icon: 'mdi-magnify',
        to: 'StockMappingFindProduct',
        keywords: ['หาสินค้า', 'ค้นหาสินค้า', 'ตำแหน่งสินค้า', 'find', 'location', 'mapping']
      },
      {
        title: 'Print Location',
        icon: 'mdi-printer',
        to: 'StockMappingPrintLocation',
        keywords: ['พิมพ์ตำแหน่ง', 'print', 'location', 'mapping']
      }
    ]
  },
  {
    title: 'Delivery Booking',
    icon: 'mdi-truck-delivery',
    subMenus: [
      {
        title: 'Booking Holiday',
        icon: 'mdi-calendar-remove',
        to: 'DeliveryBookingHoliday',
        keywords: ['วันหยุดจอง', 'holiday', 'booking']
      },
      {
        title: 'Booking Slots',
        icon: 'mdi-clock-time-four-outline',
        to: 'DeliveryBookingSlots',
        keywords: ['ช่วงเวลาจอง', 'slot', 'booking']
      },
      {
        title: 'Booking List',
        icon: 'mdi-format-list-bulleted',
        to: 'DeliveryBookingList',
        keywords: ['รายการจอง', 'booking', 'list']
      },
      {
        title: 'Manual',
        icon: 'mdi-book-open-page-variant-outline',
        to: 'DeliveryBookingManual',
        keywords: ['คู่มือ', 'manual', 'booking']
      }
    ]
  },
  {
    title: 'Production Plan',
    icon: 'mdi-cog',
    subMenus: [
      {
        title: 'Lark Production Plan',
        icon: 'mdi-chart-gantt',
        to: 'ProductionPlanOld',
        keywords: ['แผนการผลิต', 'lark', 'production', 'plan']
      },
      {
        title: 'Overview',
        icon: 'mdi-view-dashboard-outline',
        to: 'ProductionPlanOverview',
        keywords: ['overview', 'ภาพรวม', 'สรุป', 'dashboard']
      },
      {
        title: 'Time And Action',
        icon: 'mdi-calendar',
        to: 'TimeAndAction',
        keywords: ['ไทม์ไลน์', 'time', 'action', 'tna']
      },
      {
        title: 'Workflow Setup',
        icon: 'mdi-application-cog',
        to: 'Workflow',
        keywords: ['ตั้งค่าเวิร์กโฟลว์', 'workflow', 'setup']
      },
      {
        title: 'Custom Field',
        icon: 'mdi-form-textbox',
        to: 'ProductionPlanCustomField',
        keywords: ['คัสตอมฟิลด์', 'custom', 'field', 'ฟิลด์']
      },
      {
        title: 'Health Check',
        icon: 'mdi-chart-bar-stacked',
        to: 'HealthCheck',
        keywords: ['ตรวจสุขภาพแผน', 'health', 'check']
      },
      {
        title: 'My Completion Rate',
        icon: 'mdi-chart-line',
        to: 'MyCompletionRate',
        keywords: ['อัตราความสำเร็จ', 'completion', 'rate']
      },
      {
        title: 'Calendar',
        icon: 'mdi-calendar-month',
        to: 'ProductionPlanCalendar',
        keywords: ['ปฏิทิน', 'calendar']
      }
    ]
  },
  {
    title: 'Warehouse KPI',
    icon: 'mdi-cog',
    subMenus: [
      {
        title: 'Dashboard',
        icon: 'mdi-monitor-dashboard',
        to: 'WarehouseWorkDashboard',
        keywords: ['แดชบอร์ดคลัง', 'warehouse', 'kpi', 'dashboard']
      },
      {
        title: 'Employee Status',
        icon: 'mdi-list-status',
        to: 'WarehouseEmployeeStatus',
        keywords: ['สถานะพนักงาน', 'employee', 'status']
      },
      {
        title: 'Employee Performance',
        icon: 'mdi-chart-bar',
        to: 'WarehouseEmployeePerformance',
        keywords: ['ผลงานพนักงาน', 'employee', 'performance']
      },
      {
        title: 'Employee',
        icon: 'mdi-account',
        to: 'WarehouseEmployeeList',
        keywords: ['พนักงานคลัง', 'employee', 'list']
      },
      {
        title: 'Employee Attendance',
        icon: 'mdi-door',
        to: 'WarehouseEmployeeAttendance',
        keywords: ['การเข้างาน', 'ลงเวลา', 'employee', 'attendance']
      },
      {
        title: 'Work Type',
        icon: 'mdi-clipboard-list-outline',
        to: 'WarehouseWorkType',
        keywords: ['ประเภทงาน', 'work', 'type']
      },
      {
        title: 'Work Report',
        icon: 'mdi-file-chart-outline',
        to: 'WarehouseWorkLog',
        keywords: ['รายงานการทำงาน', 'work', 'report', 'log']
      }
    ]
  },
  {
    title: 'Factory Capacity',
    icon: 'mdi-factory',
    to: 'FactoryCapacity'
  },
  {
    title: 'Web Management',
    icon: 'mdi-application-settings',
    to: 'WebManagement',
    keywords: ['จัดการเว็บ', 'เนื้อหาเว็บ', 'web', 'management']
  },
  {
    title: 'Order Management',
    icon: 'mdi-clipboard-list-outline',
    to: 'OrderList',
    keywords: ['ออเดอร์', 'คำสั่งซื้อ', 'จัดการออเดอร์', 'order']
  },
  {
    title: 'QR Label',
    icon: 'mdi-qrcode',
    to: 'QrCode',
    keywords: ['ป้ายคิวอาร์', 'qr', 'label']
  },
  {
    title: 'RFID Label',
    icon: 'mdi-access-point',
    to: 'RFID',
    keywords: ['ป้าย rfid', 'rfid', 'label']
  },
  {
    title: 'PrintCareLabel',
    icon: 'mdi-washing-machine',
    to: 'PrintCareLabel',
    keywords: ['พิมพ์ป้ายดูแลผ้า', 'แคร์เลเบล', 'print', 'care', 'label']
  },
  {
    title: 'PrintFabric',
    icon: 'mdi-receipt',
    to: 'PrintFabricLabel',
    keywords: ['พิมพ์ป้ายผ้า', 'print', 'fabric', 'label']
  },
  {
    title: 'Move Warehouse',
    icon: 'mdi-warehouse',
    to: 'moveWarehouseList',
    keywords: ['ย้ายคลัง', 'โอนสินค้า', 'move', 'warehouse', 'transfer']
  },
  // {
  //   title: 'Barcode',
  //   icon: 'mdi-barcode',
  //   to: 'Barcode'
  // },
  // {
  //   title: 'RFID',
  //   icon: 'mdi-cube-scan',
  //   to: 'RFID'
  // }
  {
    title: 'Give feedback',
    icon: 'mdi-alert-outline',
    to: 'Feedback',
    keywords: ['แจ้งปัญหา', 'ฟีดแบ็ก', 'feedback', 'report issue']
  },
  {
    title: 'Gen QR',
    icon: 'mdi-qrcode',
    to: 'GenQR',
    keywords: ['สร้างคิวอาร์', 'generate', 'qr']
  }
]
